/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common'
import { Injectable } from '@angular/core'
import { AlertController, ModalController, Platform } from '@ionic/angular'
import * as moment from 'moment'
import { Card, CardDados, CardResumos } from '../components/card-resumo/card-resumo.component'
import { ModalColunasImpressaoComponent } from '../components/modal-colunas-impressao/modal-colunas-impressao.component'
import { tabelaFormat } from '../components/vasta-tabela/format'
import { ColunasTabela, IKpisCard } from '../utils/interfaces/tabela-colunas'
import { PropriedadesService } from './propriedades.service'
import {
  addCircleSVG,
  arrowRedoSVG,
  checkmarkCircleSVG,
  closeCircleSVG,
  femaleSVG,
  maleSVG,
  removeCircleSVG
} from './utils/svg-impressoes'
import { Print } from 'capacitor-print'

const icons = {
  'add-circle': addCircleSVG,
  'arrow-redo': arrowRedoSVG,
  'checkmark-circle': checkmarkCircleSVG,
  'close-circle': closeCircleSVG,
  female: femaleSVG,
  male: maleSVG,
  'remove-circle': removeCircleSVG
}

@Injectable({
  providedIn: 'root'
})
export class ImpressaoService {
  private dados: Array<Record<string, string | number | boolean | any>> = []
  private optionsKpiCards: IKpisCard[] = []
  private kpiValores: Record<string, string | number> | unknown = {}
  private kpisTipo: 'cards' | 'comprovante' = 'cards'
  private cardResumos: CardResumos[] = []
  private format = tabelaFormat
  private titulo = 'Relatório'

  constructor(
    private modalCtrl: ModalController,
    private decimalPipe: DecimalPipe,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private platform: Platform,
    private alertCtrl: AlertController,
    private propriedadesCtrl: PropriedadesService,
  ) { }

  private async print(colunas: ColunasTabela[], orientation: 'landscape' | 'portrait'): Promise<void> {
    const html = `
    <style>
      @page {
        size: ${orientation === 'landscape' ? 'A4 landscape' : 'A4'};
      }
      </style>

    <table>
      <thead>
        <tr>
          <th>
            <div class="header">
            <div class="logo-impressao">
              <svg width="94" height="23" viewBox="0 0 94 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_30_891)">
                <path d="M43.235 21.5561V2.69177H48.8417V3.8454H44.257V11.8265H48.3378V12.9801H44.257V21.5634H43.235V21.5561Z" fill="#3E8C83"/>
                <path d="M51.9218 21.5561V2.69177H57.8053V3.8454H52.9438V11.4419H57.1807V12.5956H52.9438V20.4097H57.7982V21.5634H51.9218V21.5561Z" fill="#3E8C83"/>
                <path d="M66.9178 21.5561L65.0938 13.6041C64.9732 13.6258 64.7958 13.6331 64.5686 13.6331H62.035V21.5561H61.0059V2.69177H64.6112C65.5551 2.69177 66.2506 2.9312 66.712 3.40281C67.1662 3.88168 67.4572 4.48389 67.5778 5.22395C67.6985 5.96401 67.7623 6.93625 67.7623 8.14792C67.7623 9.59177 67.663 10.7381 67.4571 11.5725C67.2513 12.4142 66.79 13.0019 66.0803 13.3284L67.9965 21.5561H66.9178ZM65.9952 12.0151C66.3074 11.6886 66.5061 11.2243 66.5984 10.6293C66.6907 10.0344 66.7332 9.21448 66.7332 8.17694C66.7332 7.11764 66.6907 6.29051 66.5984 5.71007C66.5061 5.12237 66.3074 4.66527 65.9952 4.33878C65.6829 4.01228 65.2003 3.8454 64.5474 3.8454H62.0421V12.5085H64.5474C65.2003 12.5085 65.6829 12.3489 65.9952 12.0151Z" fill="#3E8C83"/>
                <path d="M72.8438 21.5561V3.8454H69.856V2.69177H76.8323V3.8454H73.8445V21.5634H72.8438V21.5561Z" fill="#3E8C83"/>
                <path d="M79.7776 21.5561V2.69177H80.8067V21.5561H79.7776Z" fill="#3E8C83"/>
                <path d="M84.8875 21.5561V2.69177H85.9165V20.4097H90.2457V21.5634H84.8875V21.5561Z" fill="#3E8C83"/>
                <path d="M92.978 21.5561V2.69177H94.0071V21.5561H92.978Z" fill="#3E8C83"/>
                <path d="M11.9301 6.51546C9.63779 6.48644 7.33835 6.50095 5.06021 6.50095C4.95376 6.50095 4.92537 6.65331 5.01763 6.74763C6.38735 8.36562 7.7145 10.0416 9.141 11.6088C9.94296 12.3126 11.263 12.2256 12.214 12.2256C12.4695 12.2256 12.4411 11.87 12.4411 11.6596C12.4411 11.4565 12.4553 7.41514 12.4553 7.23375C12.4553 6.78391 12.2921 6.51546 11.9301 6.51546ZM39.1117 4.91924C37.8413 3.43186 36.5497 1.95899 35.2438 0.493375C34.8251 0.0290221 34.236 0 33.6612 0H32.8592L23.8176 0.0290221C23.4202 0.00725552 23.0228 0.0507886 22.6395 0.152366C21.1208 0.645741 20.2336 1.93722 20.2336 3.80915C20.2194 7.53123 20.2336 11.2678 20.2336 14.9899C20.2336 15.1931 20.2478 15.4035 20.2336 15.5921C20.2194 15.788 19.9923 16.1435 19.6446 16.1435H19.602C19.2542 16.1435 19.0413 15.9621 19.0129 15.5921C18.9846 15.2221 19.0129 15.1931 19.0129 14.9899C19.0129 11.2678 19.0271 7.53123 19.0129 3.80915C19.0129 1.93722 18.1258 0.645741 16.6071 0.152366C16.2238 0.0507886 15.8264 0.00725552 15.429 0.014511H5.59249C5.01763 0 4.42858 0.0290221 3.99566 0.493375C2.704 1.96625 1.42654 3.44637 0.14198 4.91924C0.0497193 5.02808 -0.056736 5.15142 0.0355252 5.28927C0.127786 5.42713 0.369085 5.3836 0.383279 5.3836H12.6256C13.4844 5.3836 13.7399 5.63028 13.7399 6.52271C13.7541 10.1505 13.7683 13.7637 13.7257 17.3915C13.6902 18.1678 14.045 18.9079 14.6625 19.3577C15.8832 20.359 17.0755 21.4183 18.3032 22.405C18.7858 22.8041 19.2188 22.9927 19.6162 22.9927H19.6304C20.0349 22.9927 20.4607 22.7968 20.9433 22.405C22.164 21.4183 23.3563 20.359 24.5841 19.3577C25.2015 18.9079 25.5564 18.1678 25.5209 17.3915C25.4783 13.7637 25.4925 10.1505 25.5067 6.52271C25.5067 5.63028 25.7622 5.3836 26.6209 5.3836H38.8633C38.8775 5.3836 39.133 5.41262 39.2111 5.28927C39.2962 5.16593 39.204 5.02808 39.1117 4.91924ZM34.2786 6.50095C31.9863 6.50095 29.6869 6.48644 27.4087 6.51546C27.0326 6.51546 26.8693 6.79117 26.8693 7.24101C26.8693 7.4224 26.8977 11.4565 26.8977 11.6669C26.8977 11.87 26.8551 12.2328 27.1106 12.2328C28.0758 12.2328 29.3817 12.3126 30.1978 11.6161C31.6172 10.0489 32.9373 8.37287 34.307 6.75489C34.3993 6.65331 34.3709 6.50095 34.2786 6.50095Z" fill="#3E8C83"/>
                </g>
              </svg>
            </div>
              <div class="titulo-impressao">
                <h1>${this.titulo}</h1>
              </div>
              <div class="header-info">
                <span>${moment().format('HH:mm DD/MM/YYYY')}</span>
                <span>${this.propriedadesCtrl.propriedadeSelecionada?.nome}</span>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="width: 100%;">
          ${this.renderizarKpiCards(this.optionsKpiCards, this.kpiValores)}
          ${this.cardResumos ? this.renderizarCardsResumo(this.cardResumos) : ''}
            <div class="headerTabela">
              ${this.renderizarHeaderTabela(colunas)}
            </div>
            <div class="content">
              ${this.renderizarLinhasTabela(colunas)}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    `

    const printWrapper = document.querySelector('#printWrapper')
    printWrapper.innerHTML = html
    setTimeout(() => {
      Print.print()
    }, 1000)
    
    // setTimeout(() => {
    //   printWrapper.innerHTML = ''
    // }, 5000)
  }

  private renderizarHeaderTabela(colunas: ColunasTabela[]): string {
    let colunasHeaderHTML = ''
    for (let coluna of colunas) {
      if(coluna.chip) continue
      colunasHeaderHTML += `<div class="header-col coluna-${coluna.tamanho || 2}">
      ${coluna.tituloSmall ? `<small>${coluna.tituloSmall}</small>` : ''}
      ${coluna.tipo == 'icon-only' ? '' : coluna.titulo || ''}</div>\n`
    }

    return colunasHeaderHTML
  }


  private escapeHtml(value: string): string {
    if (value) {
      value = value.toString()
      return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;')
    } else {
      return ''
    }
  }

  private formatValue(coluna: ColunasTabela, value: string): string {
    if (value === '' || value === undefined || value === null) {
      return ''
    }

    if (coluna.format) {
      return this.format[coluna.format](value) || ''
    }
    if (coluna.labelFormat) {
      return this.format?.[coluna.labelFormat]?.(value) || ''
    }
    return this.escapeHtml(value || (coluna?.chip ?  '' : coluna?.placeholder) || '')
  }

  private renderColumnContent(linha: any, coluna: ColunasTabela): string {
    if (coluna.chave === 'checkbox' || coluna.tipo === 'icon-only') {
      return this.renderIconOnlyColumn(linha, coluna)
    }

    const content = this.formatValue(coluna, linha[coluna.chave])
    const unit = linha[coluna.chave] && coluna.unidade ? `<small>${coluna.unidade}</small>` : ''
    const smallContent = linha[coluna.chave] && linha[coluna.small] ? `<small>${linha[coluna.small]}</small>` : ''
    const alignmentClass = coluna.chave === 'meta_nbrinco' ? 'align-right' : ''

    if (coluna.chip) {
      if(!content) return ''
  
      return `<div class="content-col coluna-${coluna.tamanho || 2} ${alignmentClass} chip">
        <span class="chip-title">${coluna.titulo}</span>
        ${content}${unit}${smallContent}
        </div>`
    } else {
      return `<div class="content-col coluna-${coluna.tamanho || 2} ${alignmentClass}">${content}${unit}${smallContent}</div>`
    }
  }

  private renderIconOnlyColumn(linha: any, coluna: ColunasTabela): string {
    const iconClass = coluna.iconeCase[linha[coluna.chave]]?.class
    return iconClass ? `<div class="content-col coluna-2">${icons[iconClass]}</div>` : ''
  }

  private renderizarLinhasTabela(colunas: ColunasTabela[]): string {
    console.warn('🚀 ~ renderizarLinhasTabela ~ this.dados:', this.dados)
    return this.dados.map(linha => {
      const colunasBody = colunas.map(coluna => this.renderColumnContent(linha, coluna)).join('')
      console.warn('🚀 ~ renderizarLinhasTabela ~ colunas, colunasBody:', colunas, colunasBody)
      return `<div class="content-row">${colunasBody}</div>\n`
    }).join('')
  }

  private renderizarKpiCards(
    optionsKpiCards: IKpisCard[],
    kpiValores: Record<string, string | number> | unknown,
    tipo: 'cards' | 'comprovante' = 'cards'
  ): string {
    let kpiCardHTML = ''
    if (optionsKpiCards?.length || Object.keys(kpiValores).length) {
      if (this.kpisTipo === 'cards') {
        for (let option of optionsKpiCards) {
          if (kpiValores[option.key] || option.valor) {
            kpiCardHTML += `
            <div class="kpi-card">
              <span>${option.titulo}</span>
              <b>${this.formatarValorCard(option)} ${option.unidade ? `<small>${option.unidade}</small>` : ''}
                ${option.indicador ? `<div class="indicador ${option.indicador}"></div>` : ''}
              </b>
            </div>`
          }
        }
      }
      if (this.kpisTipo === 'comprovante') {
        for (let option of optionsKpiCards) {
          if (kpiValores[option.key] || option.valor) {
            kpiCardHTML += `
            <div class="comprovante-item">
              <strong class="item-titulo">${option.titulo}</strong>
              <p class="item-valor">
                ${this.formatarValorCard(option)}
                <small class="unidade">
                  ${option.unidade ? option.unidade : ''}
                </small>
              </p>
            </div>
          `
          }
        }
      }
    }

    const kpiCardContainerClass = this.kpisTipo === 'cards' ? 'container-kpi-cards' : 'container-comprovante'

    return kpiCardHTML
      ? `
      <div class="${kpiCardContainerClass}">
        ${kpiCardHTML}
      </div>
    `
      : ''
  }

  private renderizarHeaderTabelaResumo(colunas: Card[]): string {
    const rowHead = document.createElement('div')
    rowHead.classList.add('row', 'head')

    for (let coluna of colunas) {
      const colunaHTML = `
        <div class="col ${coluna.bold ? 'bold' : ''} ${coluna.right ? 'right' : ''}">
          ${coluna.titulo ? `<span>${coluna.titulo}</span>` : ''}
          ${coluna.icon ? `${icons[coluna.icon]}` : ''}
        </div>
      `
      rowHead.innerHTML += colunaHTML
    }
    return rowHead.outerHTML
  }

  private renderizarLinhasTabelaResumo(colunas: Card[], dados: CardDados[]): string {
    const containerRows = document.createElement('div')

    for (let linha of dados) {
      const row = document.createElement('div')
      row.classList.add('row')
      for (let coluna of colunas) {
        const colunaHTML = `
          <div class="col ${coluna.bold ? 'bold' : ''} ${coluna.right ? 'right' : ''}">
            ${linha[coluna.chave] ? `<span>${linha[coluna.chave]}</span>` : ''}
            ${!linha[coluna.chave] && !coluna.icon ? '<span>sem registro</span>' : ''}
            ${!linha[coluna.chave] && coluna.icon ? '-' : ''}
          </div>
        `
        row.innerHTML += colunaHTML
      }
      containerRows.appendChild(row)
    }

    return containerRows.innerHTML
  }

  private renderizarCardsResumo(cards?: CardResumos[]): string {
    const cardsWrapper = document.createElement('div')
    cardsWrapper.classList.add('cards-wrapper')

    for (let card of cards) {
      if (card.dados.length > 0) {
        const cardHTML = `
        <div class="custom-card">
          <h2>${card.titulo}</h2>
          <div class="tabela-simples">
            ${this.renderizarHeaderTabelaResumo(card.colunas)}
            ${this.renderizarLinhasTabelaResumo(card.colunas, card.dados)}
          </div>
        </div>
      `
        cardsWrapper.innerHTML += cardHTML
      }
    }

    return cardsWrapper.outerHTML
  }

  async configurarImpressao(
    colunas: ColunasTabela[],
    dados: Array<unknown>,
    titulo?: string,
    optionsKpiCards?: IKpisCard[],
    kpiValores?: Record<string, string | number> | unknown,
    kpisTipo?: 'cards' | 'comprovante',
    cardResumos?: CardResumos[]
  ): Promise<void> {
    if (optionsKpiCards) {
      this.optionsKpiCards = optionsKpiCards
    } else {
      this.optionsKpiCards = []
    }

    if (kpiValores) {
      this.kpiValores = kpiValores
    } else {
      this.kpiValores = {}
    }

    if (kpisTipo) {
      this.kpisTipo = kpisTipo
    }

    if (titulo) {
      this.titulo = titulo
    } else {
      this.titulo = 'Relatório'
    }
    if (cardResumos) {
      this.cardResumos = cardResumos
    } else {
      this.cardResumos = null
    }
    this.dados = dados
    const colunasProp = colunas.filter((item) => !['checkbox', 'mais'].includes(item.chave))
    const modal = await this.modalCtrl.create({
      component: ModalColunasImpressaoComponent,
      componentProps: { colunasProp },
      cssClass: 'custom-modal'
    })

    await modal.present()
    const { data } = await modal.onWillDismiss()
    if (data) {
      this.print(data.colunasSelecionadas, data.layout)
    }
  }

  converterImgParaBase64(imgSrc: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const imgElement = document.createElement('img')
      imgElement.src = imgSrc
      imgElement.onload = (): void => {
        const canvas = document.createElement('canvas')
        canvas.width = imgElement.width
        canvas.height = imgElement.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(imgElement, 0, 0)
        const dataURL = canvas.toDataURL('image/png')
        resolve(dataURL)
      }
      imgElement.onerror = (err): void => {
        reject(err)
      }
    })
  }

  formatarValorCard(card: IKpisCard): string | number {
    if (card.formatacao === 'currency' && (this.kpiValores[card.key] || card.valor)) {
      return this.currencyPipe.transform(this.kpiValores[card.key] || card.valor, 'BRL')
    }
    if (card.formatacao === 'date' && (this.kpiValores[card.key] || card.valor)) {
      return this.datePipe.transform(this.kpiValores[card.key] || card.valor, 'dd/MM/yyyy')
    }
    if (card.formatacao === 'number' && (this.kpiValores[card.key] || card.valor)) {
      return this.decimalPipe.transform(this.kpiValores[card.key] || card.valor, '1.0-2')
    }
    return this.kpiValores[card.key] || card.valor || 0
  }
}
